import { useAmbassadorCodeStore } from './useAmbassadorCodeStore'

/**
 * Convenience access to the persisted ambassador referral code.
 * Wraps the store so components don't reach into it with raw selectors.
 */
export function useAmbassadorCode() {
  const ambassadorCode = useAmbassadorCodeStore((s) => s.ambassadorCode)
  const setAmbassadorCode = useAmbassadorCodeStore((s) => s.setAmbassadorCode)
  const removeAmbassadorCode = useAmbassadorCodeStore(
    (s) => s.removeAmbassadorCode
  )

  return { ambassadorCode, setAmbassadorCode, removeAmbassadorCode }
}
